import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import * as HelpLinksAPI from '../REST/administration';
import Typography from '@material-ui/core/Typography';

class HelpLinks extends Component {
    state = {
        helpLinksEntity: []
      

    }

    componentDidMount() {
        HelpLinksAPI.GetHelpLinks().then(data => {
            if (data) {
                this.setState({ helpLinksEntity: data.data });
            }
        })
    }

    render() {
        return (
            <div>               
                <Typography variant="h6" className="Help">
                        Help
                </Typography>           
            <div className="card row rounded-0 bg-dark d-block border-secondary border-bottom-0 border-left-0 border-right-0">
                <div className="card-body bg-white">
                    <div className="row">
                        <div className="col-sm-12 text-left">
                            {this.state.helpLinksEntity.map(
                                data =>
                                    (<div key={data.id} className="col-sm-12 col-md-6 col-lg-6 col-xs-12">
                                        {/*<label className="col-4 align_topleft "><h5> <b>{data.nameOfLink}</b> </h5></label>*/}
                                        <label className="col-8 align_topleft "> <a href={data.helpLink} target="_blank" className="tip"> <h5>{data.nameOfLink}</h5></a></label>
                                    </div>))
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

export default withRouter(HelpLinks);